import { render, staticRenderFns } from "./GoalsSetting.vue?vue&type=template&id=02482b60&scoped=true&"
import script from "./GoalsSetting.vue?vue&type=script&lang=js&"
export * from "./GoalsSetting.vue?vue&type=script&lang=js&"
import style0 from "./GoalsSetting.vue?vue&type=style&index=0&id=02482b60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02482b60",
  null
  
)

export default component.exports